import { memo } from 'react';
import BinIcon from '../icon/Icon';
import { CarouselControlIconWrapperStyled } from './styled/CarouselControlIconStyled';

interface ICarouselControlIconProps {
    hasNext?: boolean;
    onClick: () => void;
    prev?: boolean;
}

function CarouselControlIcon(props: ICarouselControlIconProps) {
    const { hasNext, onClick, prev } = props;

    return <CarouselControlIconWrapperStyled hasNext={hasNext} onClick={onClick} prev={prev}>
        <BinIcon
            name='IcNextRound'
            size={32}
            style={{ transform: `rotate(${prev ? 180 : 0}deg)` }}
        />
    </CarouselControlIconWrapperStyled>;
}

export default memo(CarouselControlIcon);
